// When built, it will be output as bleuclair/javascripts/theme.js
import './scripts/bleuclair.js'

// When built, it will be output as bleuclair/stylesheets/theme.css
import './styles/bleuclair.scss';
